import React, { useMemo } from "react";
import { Flex, Text, TextProps, ButtonProps, Button } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";

export type TitlebarProps = {
  title: string;
  variant?: TextProps["variant"];
  marginBottom?: TextProps["marginBottom"];
  actionButtons?: TitlebarAction[];
};

export type TitlebarAction = {
  show: boolean;
  buttonProps?: ButtonProps;
  component?: React.ReactNode;
};

const useTitlebarActions = (actions?: TitlebarAction[]) => {
  const actionButtons = useMemo(() => {
    if (!actions) return null;
    return actions?.filter((action) => action.show);
  }, [actions]);

  return actionButtons?.map((action) => {
    if (action.component) {
      return action.component;
    }

    if (action.buttonProps) {
      return <Button key={action.buttonProps?.key} {...action.buttonProps} />;
    }

    return null;
  });
};

const Titlebar = ({ title, variant, actionButtons, marginBottom }: TitlebarProps) => {
  const actions = useTitlebarActions(actionButtons);
  return (
    <Flex flexDirection="row" justifyContent="space-between" alignItems="center">
      <Text variant={variant} marginBottom={marginBottom}>
        {title}
      </Text>
      {actionButtons && (
        <Flex flexDirection="row" gap={SPACING.MEDIUM}>
          {actions}
        </Flex>
      )}
    </Flex>
  );
};

export default Titlebar;
